import './WaterDroplets.css';

import React, { useEffect, useState } from 'react';

interface WaterDropletsProps {
  onComplete: () => void;
  triggerKey: number; // Add a key to allow multiple triggers
}

export const WaterDroplets: React.FC<WaterDropletsProps> = ({ onComplete, triggerKey }) => {
  const [droplets, setDroplets] = useState<
    Array<{ id: number; x: number; size: number; delay: number; horizontalDrift: number }>
  >([]);
  const onCompleteRef = React.useRef(onComplete);

  // Update the ref when onComplete changes
  React.useEffect(() => {
    onCompleteRef.current = onComplete;
  }, [onComplete]);

  useEffect(() => {
    // Generate random droplets with realistic physics
    const newDroplets = Array.from({ length: 200 }, (_, i) => ({
      id: i + triggerKey * 1000, // Unique ID based on trigger
      x: Math.random() * 100, // Random starting x position as percentage
      size: 12 + Math.random() * 24, // Random size between 12px and 36px
      delay: Math.random() * 1.5, // Random delay up to 1.5s
      horizontalDrift: (Math.random() - 0.5) * 300, // Random horizontal drift -150px to +150px
    }));

    setDroplets(newDroplets);

    // Clean up after animation completes
    const timer = setTimeout(() => {
      onCompleteRef.current();
    }, 3600); // Animation duration + buffer

    return () => clearTimeout(timer);
  }, [triggerKey]); // Only depend on triggerKey

  return (
    <div className="water-droplets-container">
      {droplets.map((droplet) => (
        <div
          key={droplet.id}
          className="water-droplet"
          style={
            {
              left: `${droplet.x}%`,
              top: '0px',
              width: `${droplet.size}px`,
              height: `${droplet.size}px`,
              animationDelay: `${droplet.delay}s`,
              '--horizontal-drift': `${droplet.horizontalDrift}px`,
            } as React.CSSProperties & { '--horizontal-drift': string }
          }
        />
      ))}
    </div>
  );
};
